<template>
    <!-- contents -->
    <div id="contents">
        <div class="contents_wrap">
            <h2 class="pg_title">{{pageTitle}}</h2>
            <skp-breadcrumbs @page-title="val => pageTitle = val" />
            <div v-if="mode == 'search'">
                <!-- srchTop_wrap -->
                <div class="srchTop_wrap">
                    <article class="srch_basic">
                        <div class="srch_grup">
                            <ul class="w50">
                                <li class="tit_150">{{$t('FIELD.LOCALE.RESOURCE.NAME')}}</li>
                                <li data-input-type="text" class="w100-150">
                                    <span class="clearable">
                                        <input type="text" class="text_input w100" v-model="resNm" @keyup.enter.stop="search(1)" v-clearable />
                                        <i class="clearable_clear">X</i>
                                    </span>
                                </li>
                            </ul>
                            <ul class="w50">
                                <li class="tit_150">{{$t('FIELD.LOCALE.RESOURCE.ID')}}</li>
                                <li data-input-type="text" class="w100-150">
                                    <span class="clearable">
                                        <input type="text" class="text_input w100" v-model="resId" @keyup.enter.stop="search(1)" v-clearable />
                                        <i class="clearable_clear">X</i>
                                    </span>
                                </li>
                            </ul>
                            <ul class="w50">
                                <li class="tit_150">{{$t('FIELD.ADMIN.LABEL.SETTING')}}</li>
                                <li data-input-type="text" class="w100-150">
                                    <span class="clearable">
                                        <input type="text" class="text_input w100" v-model="labelInfo" @keyup.enter.stop="search(1)" v-clearable />
                                        <i class="clearable_clear">X</i>
                                    </span>
                                </li>
                            </ul>
                            <ul class="w50">
                                <li class="tit_150">{{$t('FIELD.LOCALE.RESOURCE.TYPE')}}</li>
                                <li data-input-type="select" class="w100-150">
                                    <select class="slt_white w100" v-model="resType">
                                        <option value selected>{{$t('FIELD.FAST.DURATION.ALL')}}</option>
                                        <option v-for="type in resourceTypes" :key="type.code" :value="type.code" >{{type.codeName}}</option>
                                    </select>
                                </li>
                            </ul>
                            <ul class="w50">
                                <li class="tit_150">{{$t('FIELD.GLOBAL.USE')}}</li>
                                <li data-input-type="select" class="w100-150">
                                    <select class="slt_white w100" v-model="useYn">
                                        <option value selected>{{$t('FIELD.FAST.DURATION.ALL')}}</option>
                                        <option value="N">{{$t('FIELD.GLOBAL.NO')}}</option>
                                        <option value="Y">{{$t('FIELD.GLOBAL.YES')}}</option>
                                    </select>
                                </li>
                            </ul>
                        </div>
                        <div class="srch_grupR">
                            <span class="btn">
                                <a href="JavaScript:" class="btn_srch" @click="clickSearch(1)" >{{$t('BUTTON.GLOBAL.SEARCH')}}</a>
                            </span>
                        </div>
                    </article>
                </div>

                <!-- Grid -->
                <div class="grid_wrap">
                    <div class="grid_total">
                        {{$t('TITLE.TOTAL.COUNT')}} :
                        <em>{{ resultCount | numberFormat }}</em>
                    </div>
                    <!-- Grid btn-->
                    <div class="btn_wrap">
                        <a href="JavaScript:" class="btn_gray" @click="clickCreate()">{{$t('BUTTON.GLOBAL.CREATE')}}</a>
                    </div>

                    <!-- Grid -->
                    <resrc-list-grid
                        :gridId="gridId"
                        :data="gridData"
                        :columns="columns"
                        :options="options"
                        :pageOptions="pageOptions"
                        :key="gridKey"
                        :click="contentClick"
                        :isTotalCount="false"
                        :menuMode="menuMode"
                    />
                </div>
            </div>
            <content-view v-if="mode !== 'search'" :pResId="resourceId" :pResTypes="resourceTypes"></content-view>
        </div>
    </div>
    <!-- contents -->
</template>

<script>
import Vue              from 'vue';
import axios            from 'axios';
import qs               from 'query-string';
import _                from 'lodash';
import $                from 'jquery';
import SDLPagination    from '~~c/control/pagination/Pagination';
import { SDLUtil }      from '@/utils';
import { EventBus }     from '@/utils/EventBus';
import SKPBreadcrumbs   from '~vb/main/SKPBreadcrumbs';
import ResrcListGrid    from '~c/ToastGrid';
import ResrcAdminView   from './ResourceAdminView';
import api              from '@/service';

export default {
    name: 'ResrcAdminList',
    props: {
        params: {},
    },
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
        'sdl-pagination': SDLPagination,
        'resrc-list-grid': ResrcListGrid,
        'content-view': ResrcAdminView,
    },
    data() {
        return {
            isLoading: true,
            mode: 'search', // 'view'
            loadingStatus: 'loading', // 'done', 'error'
            searchStatus: 'done', // 'loading', 'disabled'
            menuMode: 'RSRC',
            pageTitle: '',
            resId: '',
            resNm: '',
            resType: '',
            labelInfo: '',
            useYn: '',
            perPage: parseInt(localStorage.getItem('listRows') || 10),
            currentPage: 1,
            gridKey: 0,
            resultCount: 0,
            resourceId: '',
            ORDER_COLUMN: '',
            ORDER_ASC: '',
            sortOrder: null, // ASC or DESC
            orgOrderCol: null,
            gridId: 'resrcAdminGrid',
            options: {},
            pageOptions: {},
            resourceTypes: [],
            gridData: [],
            searchFormData: {},
            columns: [
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.TYPE'),
                    name: 'RESTYPENM',
                    width: 130,
                    align: 'center',
                    sortable: true,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.ID'),
                    name: 'RESID',
                    width: 400,
                    sortable: true,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.NAME'),
                    name: 'RESNM',
                    sortable: true,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.USE.STATUS'),
                    name: 'USEYN',
                    align: 'center',
                    width: 130,
                    sortable: true,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.ADDED.DATE'),
                    name: 'REGDT',
                    align: 'center',
                    width: 110,
                    sortable: true,
                }
            ],
            options: {
                scrollY: false,
                scrollX: false,
                rowHeight: 25,
            },
            pageOptions: {
                useClient: true,
                perPage: parseInt(localStorage.getItem('listRows') || 10),
            }
        };
    },
    computed: {},
    watch: {},
    methods: {
        search(pageNo) {
            if (!pageNo) pageNo = 1;

            const formData = this.prepSearchParams(pageNo);

            SDLUtil.showLoadingBar(true);
            this.gridData = [];
            this.searchStatus = 'loading';
            return axios
                .post(`${SDLUtil.API_URL}/basis/admin/system/resource/resSearchList.skp`, qs.stringify(formData), {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    params: { searchInfo: 'set' },
                })
                .then(resp => {
//                    console.log('resp => ', resp);
                    this.resultCount = resp.data.totalCount;
                    console.log('ResourceList.rows => ', resp.data.rows);
                    this.gridData = resp.data.rows;

                    // Server에서 결과가 10개 미만일 때 항상 10을 돌려주는 문제를 임시적으로 해결하는 if문
                    if (
                        this.resultCount === 10 &&
                        typeof resp.data.rows !== 'undefined' &&
                        resp.data.rows.length < 10
                    ) {
                        this.resultCount = resp.data.rows.length;
                    }
                    this.searchStatus = 'done';
                    this.loadingStatus = 'done';

                    this.currentPage = pageNo;
                    this.gridKey += 1; // This will re-render grid
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error('SEARCH ERROR =>> ', err);
                    this.searchStatus = 'error';
                    this.gridData = [];
                    SDLUtil.showLoadingBar(false);
                });
        },
        initLoad() {
            api.getCommonCodeList('RESOURCE_TYPE_CD', 'A').then(resp => {
                this.resourceTypes = resp;
            });
            this.search(1);
        },
        // 그리드 row 클릭 시...
        clickCreate() {
            this.resourceId = null;
            this.mode = 'view';
        },
        // 그리드 row 클릭 시...
        contentClick(event) {
            if (typeof event.rowKey === 'undefined') return;
            this.fetchContent(event.rowKey);
        },
        // 상세페이지로 이동
        fetchContent(rowIdx) {
            let item = this.gridData[rowIdx];
            SDLUtil.showLoadingBar(true);

            this.resourceId = item.RESID;
            console.log('this.resourceId ==> ', this.resourceId);
            this.mode = 'view';

            window.scrollTo(0, 0);
            SDLUtil.showLoadingBar(false);
        },
        prepSearchParams(pageNo, exclude = []) {
            if (!pageNo) pageNo = 1;

            let params = {
                page: pageNo,
                currentPage: pageNo,
                perPage: this.perPage,
                resNm: this.resNm,
                resId: this.resId,
                resType: this.resType,
                labelInfo: this.labelInfo,
                useYn: this.useYn,
                ORDER_COLUMN: this.ORDER_COLUMN,
                ORDER_ASC: this.ORDER_ASC,
            };
            return params;
        },

        clickSearch() {
            this.search(1);
        }, // clickSearch
        goList(data) {
            console.log('REsourceAamin.goList.data ====> ', data);
            this.search(this.currentPage);
            this.mode = 'search';
        },
        // 정렬 조회 - 정렬로 조회하는 경우, 페이지를 1로 초기화 한다.
        handleSortSearch(sortObj) {
            this.ORDER_COLUMN = sortObj.columnName;

            if (this.ORDER_COLUMN != this.orgOrderCol) {
                this.sortOrder = null;
            }
            if (this.sortOrder == null) this.sortOrder = 'ASC';
            else if (this.sortOrder == 'ASC') this.sortOrder = 'DESC';
            else if (this.sortOrder == 'DESC') {
                this.sortOrder = null;
                this.ORDER_COLUMN = null;
            }

            console.log('this.ORDER_COLUMN ==> ', this.ORDER_COLUMN);
            this.ORDER_ASC = this.sortOrder;
            this.orgOrderCol = this.ORDER_COLUMN;
            this.search(1);
        },
    }, // methods
    created() {
        EventBus.$on('go-back-rsrc-list', this.goList);
        EventBus.$on('sort-search-rsrc', sortForm => {
            this.handleSortSearch(sortForm);
        });
    },
    mounted() {
        this.initLoad();
    },
    beforeDestroy() {
        // [필수] EventBus 를 통해 등록된 이벤트는 컴포넌트 종료시 반드시 종료한다.
        EventBus.$off('go-back-rsrc-list');
        EventBus.$off('sort-search-rsrc');
    },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/system/resource/ResourceAdminList.vue